<template>
	<div style="text-align: left; margin-bottom: 30px; padding:20px">
		<el-row :gutter="20">
			<el-col :sm="8" :xs="24">
				<label for="">Estado del pedido</label> <br />
				<el-select style="width: 100%; text-align: left !important" v-model="option" @change="getPedido()">
					<el-option style="width: 100%; text-align: left !important" v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
				</el-select>
			</el-col>
			<el-col :sm="6" :offset="0">
				<label for="">vtex_id</label> <br />
				<el-input type="text" v-model="pedido" @keypress.native.enter="pedidoManual1" />
			</el-col>
			<el-col :sm="8" :offset="0">
				<el-button style="margin-top: 19px" type="success" :loading="yendo" size="medium" @click="pedidoManual" icon="el-icon-arrow-right">   </el-button>
					<!-- <el-button style="margin-top: 19px" type="warning" :loading="yendo" size="medium" @click="pedidoManual1" icon="el-icon-arrow-right">   </el-button> -->
				<el-button style="margin-top: 19px" type="primary" :loading="reinciando" size="medium" @click="reiniciarPedido" icon="el-icon-"> REINICIAR {{ pedido }} </el-button>
			</el-col>
		</el-row>
		<span @click="reiniciarPedido" style="position:absolute; top:0%; right:0; cursor:pointer" class="el-icon-plus"></span>
	</div>
</template>

<script>
import {HTTP} from '@/axios'
export default {
	data() {
		return {
			reinciando: false,
			token: 0,
			yendo:false,
			option: '',
			options: [
				{
					value: 10,
					label: 'Pedido en Preparacion',
				},
				{
					value: 101,
					label: 'Pedido en Preparacion - Domicilio',
				},
				{
					value: 20,
					label: 'Pedido Despachado',
				},
				{
					value: 201,
					label: 'Pedido Despachado - Domicilio',
				},
					{
					value: 202,
					label: 'Pedido Demorado',
				},
				{
					value: 30,
					label: 'Pedido Disponible',
				},
				{
					value: 40,
					label: 'Pedido Entregado',
				},
				{
					value: 49,
					label: 'Pedido con falta de stock',
				},
				{
					value: 491,
					label: 'Pedido Entregado y con falta de stock',
				},
				{
					value: 311,
					label: 'Env. Dom. en Progreso',
				},
				{
					value: 321,
					label: 'Domicilio No Entregado',
				},
				{
					value: 411,
					label: 'Entrega en Domcilio',
				},
			],
			refresh: true,
			url: 'https://pv.farmaonline.com/#/ayuda/',
			// url: 'http://localhost:8080/#/reclamo/',
			pedido: this.$route.params.pedido ? this.$route.params.pedido : '' ,
		}
	},
	created() {
		this.token = '56VUhem3qbvOo1GkVIi0W6K7PwCrHA7L'
		this.pedido = this.$route.params.pedido 
		// setTimeout(() => {
		//     this.getPedido(10)
		// }, 100);
	},
	 mounted() {
    window.addEventListener("keypress", e => {
      console.log(String.fromCharCode(e.keyCode));
    });
  },
	methods: {
		pedidoManual() {
this.yendo = true
			if(this.pedido != this.$route.params.pedido)
			{
this.yendo = false
				let url = this.$router.resolve(
				{ name: 'reclamo', params: {pedido: this.pedido}, },
				// () => {
				// 	this.$router.go(0);
				// }
				);
				window.open(url.href, '_blank')
			}
			
		},
				pedidoManual1() {
			this.yendo = true
			if (this.pedido != this.$route.params.pedido) {
				this.yendo = false
				let url = this.$router.resolve(
					{ name: 'arbol', params: { pedido: this.pedido }, },
					// () => {
					// 	this.$router.go(0);
					// }
				);
				window.open(url.href, '_blank')
			}

		},
		refreshPed() {
			this.refresh = undefined
			setTimeout(() => {
				this.refresh = true
			}, 100)
		},
		reiniciarPedido() {
			if(this.pedido)
			{
				this.$confirm('Reiniciar  ' + this.pedido, 'CUIDADO', {
					confirmButtonText: 'REINICIAR',
					cancelButtonText: 'Cancelar',
					type: 'success',
				}).then(() => {
					this.reinciando = true
					HTTP.post('https://caba33.suizoargentina.com.ar/sellerpostventaold/reiniciarPedido', {
						pedido: this.pedido
					}).then((res) => {
						console.log(res)
						this.reinciando = false
						this.pedido = res.data ? res.data : 0

						let url = this.$router.resolve(
							{ name: 'reclamo', params: { pedido: res.data }, },
							// () => {
							// 	this.$router.go(0);
							// }
						);
						// console.log(url);
						window.open(url.href, '_blank')
					})
				})
				
				
			}
			
		},
		getPedido() {
			console.log(this.option)

			HTTP.post('https://caba33.suizoargentina.com.ar/sellerpostventaold/getPedidoByEstado', {
				estado: this.option,
				token: this.token,
			}).then((res) => {
				console.log(res)
				this.pedido = res.data ? res.data.vtex_id : 0
			

			let url = 	this.$router.resolve({ name: 'reclamo', params: {pedido: res.data.vtex_id}});

				window.open(url.href, '_blank')
			})
		},
	},
}
</script>

<style lang="scss" scoped></style>
